export const
    csGoodPro = {
        path: "/safetyCheck/cstGoodPro",
        component: require("@/components/pages/safetyCheck/cstGoodPro/main.vue"),
        children: [{ //省级优良项目申报(登记)
                path: "/safetyCheck/cstGoodPro/GoodDeclare",
                component: resolve => require(["@/components/pages/safetyCheck/cstGoodPro/GoodDeclare.vue"], resolve),
                meta: { componentName: "GoodDeclare" }
            },
            { //省级优良项目创建工程汇总表
                path: "/safetyCheck/cstGoodPro/GoodSum",
                component: resolve => require(["@/components/pages/safetyCheck/cstGoodPro/GoodSum.vue"], resolve),
                meta: { componentName: "GoodSum" }
            },
        ]
    }


// WEBPACK FOOTER //
// ./src/router/csGoodPro.js